export default __webpack_public_path__ + "static/media/sharp-50.512e8ea5.jpg";